import { lazy, Suspense } from 'react';
import { Skeleton } from '@xinfer/ui';
import type { UsageTotals } from '@xinfer/api-client';

/**
 * The chart, split out of the initial bundle.
 *
 * Recharts and its d3 dependencies are the largest single thing this app
 * imports, and they are needed by exactly two cards. Loading them lazily means
 * sign-in, Keys, Limits and Quickstart never pay for them at all, and Overview
 * paints its stat cards — the numbers people actually came for — without
 * waiting on charting code.
 */
const TokenCompositionChart = lazy(() =>
  import('./TokenCompositionChart').then((module) => ({ default: module.TokenCompositionChart })),
);

export function TokenComposition({ usage }: { usage: UsageTotals }) {
  return (
    <Suspense fallback={<Skeleton className="h-[214px] w-full" />}>
      <TokenCompositionChart usage={usage} />
    </Suspense>
  );
}
